// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AuthTestResponse = SlackAPIResponse & {
  app_id?: string;
  app_name?: string;
  bot_id?: string;
  context?: string;
  enterprise_id?: string;
  error?: string;
  expires_in?: number;
  is_enterprise_install?: boolean;
  needed?: string;
  ok: boolean;
  provided?: string;
  team?: string;
  team_id?: string;
  url?: string;
  user?: string;
  user_id?: string;
};
